import {BBModel} from "../bb_model";
import {context} from "../constants/context";

const member = {
    refresh(member) {
        return new Promise((resolve, reject)=>{
        member.$flush('self');
        member.$get('self').then((member) => {
                member = new BBModel.Member.Member(member);
                return resolve(member);
            }
            , (err) => {
                return reject(err);
            }
        );
        });
    },

    current() {
        return new Promise((resolve, reject)=> {
            //const callback = () => resolve($rootScope.member); //TODO !!!
            const callback = () => resolve(context.member);
            setTimeout(callback, 200);
            // member = () ->
            // deferred.resolve($rootScope.member)
        });
    },

    updateMember(member, params) {
        return new Promise((resolve, reject)=> {
            member.$put('self', {}, params).then((member) => {
                    member = new BBModel.Member.Member(member);
                    return resolve(member);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    sendWelcomeEmail(member, params) {
        return new Promise((resolve, reject)=> {
            member.$post('send_welcome_email', params).then((member) => {
                    member = new BBModel.Member.Member(member);
                    return resolve(member);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

export {
    member
}